var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralCertificationPurchaseLabel = function SvgGeneralCertificationPurchaseLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF540F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.078 2.128V9.57H11V2.13h1.173v2.364h1.732V2.128zm2.602 4.014v3.776h-1.218V2h1.218v2.978h1.027v1.164zM12.173 8.47h1.732V5.61h-1.732zM26.225 6.032v1.054h-6.892V4.062h5.59v-.88h-5.59V2.128h6.81v2.97h-5.59v.934zm.302 2.474v1.11H18.95v-1.11h3.134V7.397h1.283v1.11zM34.393 6.261h-1.219V3.246h-5.59V2.128h6.81zm.385.513v1.127h-3.143V10h-1.292V7.901H27.2V6.774zM38.988 2.128V9.57h-3.235V2.13zm-2.099 6.35h.953v-5.25h-.953zM42.6 2v7.918h-1.155V6.133h-.688v3.693h-1.145v-7.79h1.145v2.988h.688V2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M5.833 4.75V2.441c0-.587-.66-.832-.963-.357L2.186 6.286c-.256.401-.004.964.431.964h1.55v2.309c0 .587.66.832.963.357l2.684-4.202c.256-.401.004-.964-.431-.964z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralCertificationPurchaseLabel;